"use client";

import { Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Procurement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.18
  });
  const stats = [{
    value: "15+",
    label: "years of expertise"
  }, {
    value: "500+",
    label: "projects supplied",
    star: true
  }, {
    value: "UAE",
    label: "nationwide logistics"
  }];
  return <section data-section-id="1351" id="b2b-procurement-support" className="bg-slate-950 text-foreground relative overflow-hidden py-24 md:py-24">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'><g fill='none' stroke='hsl(215 16% 47%)' stroke-width='1'><path d='M0 40 L 40 0'/><path d='M0 0 L 40 40'/></g></svg>\")",
      backgroundRepeat: "repeat",
      backgroundSize: "40px 40px"
    }} aria-hidden="true" />

      <div ref={ref} className={`relative z-10 mx-auto max-w-5xl px-8 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex items-center justify-center gap-4 mb-8">
          <span className="inline-block w-1 h-4" style={{
          backgroundColor: "hsl(199 89% 48%)"
        }} aria-hidden="true" />
          <span className="font-default uppercase text-sm tracking-[0.2em] font-medium" style={{
          color: "hsl(199 89% 48%)"
        }}>
            B2B PROCUREMENT SOLUTIONS
          </span>
          <span className="inline-block w-1 h-4" style={{
          backgroundColor: "hsl(199 89% 48%)"
        }} aria-hidden="true" />
        </div>

        {}
        <div className="relative flex items-center justify-center mb-10">
          <h2 className="relative font-default font-bold text-foreground leading-[1.1] tracking-tighter" style={{
          fontSize: "clamp(2.5rem, 5vw, 5rem)"
        }}>
            Engineered Precision for <br />
            <span className="text-sky-500">Large-Scale Construction</span>
          </h2>
        </div>

        {}
        <p className="font-default mx-auto max-w-2xl text-foreground/80 mb-12" style={{
        fontSize: "1.25rem",
        lineHeight: 1.6
      }}>
          Optimizing supply chains for UAE's leading contractors. We deliver high-volume, precision-engineered aluminum profiles and architectural hardware with the reliability and technical documentation required for major infrastructure and commercial developments.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-20">
          <Button asChild className="bg-sky-500 text-white font-default font-semibold hover:bg-sky-600 transition-all duration-200" style={{
          padding: "12px 28px",
          height: "auto",
          borderRadius: "2px",
          fontSize: "1rem"
        }}>
            <Link to="#">Request Quote</Link>
          </Button>

          <Button asChild className="bg-sky-500 text-white font-default font-semibold hover:bg-sky-600 transition-all duration-200" style={{
          padding: "12px 28px",
          height: "auto",
          borderRadius: "2px",
          fontSize: "1rem"
        }}>
            <Link to="https://wa.me/971527750331">WhatsApp Inquiry</Link>
          </Button>
        </div>

        {}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
          {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-center gap-3">
              {stat.star && <Star className="w-5 h-5" style={{
            color: "hsl(199 89% 48%)",
            fill: "hsl(199 89% 48%)"
          }} aria-hidden="true" />}
              <span className="font-default font-bold text-foreground" style={{
            fontSize: "1.5rem"
          }}>
                {stat.value}
              </span>
              <span className="font-default text-foreground/60 text-sm uppercase tracking-wider">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}